import { Command } from 'commands/Commands';

export class AddAwardToBusiness extends Command {
  type: string = 'Award.AddToBusiness';
  constructor(payload: string, id: string = payload) {
    super(payload, id);
  }
  priority: number = 100;
}
